import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  GET_ITEMWISE_SALE_LIST,
  GET_TOP_PRODUCT_SOLD,
  REPORTS_BASE_URL,
  IS_PY_GRAPHS,
  REPORTS_TOP_SOLD_PRODUCTS,
} from "../../../../Constants/Config";

const initialState = {
  loading: false,
  ItemSalesData: [],
  GetTopProductSold: [],
  status: false,
  successMessage: "",
  error: "",
};
let cancelTokenSource;
// Generate pening , fulfilled and rejected action type
export const fetchItemSalesData = createAsyncThunk(
  "ItemSalesSlice/fetchItemSalesData.",
  async (data, { rejectWithValue }) => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Previous request canceled");
    }

    // Create a new cancel token
    cancelTokenSource = axios.CancelToken.source();

    try {
      const { token, ...dataNew } = data;

      const response = await axios.post(
        BASE_URL + GET_ITEMWISE_SALE_LIST,
        dataNew,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          cancelToken: cancelTokenSource.token,
        }
      );
      if (response.data.status === true) {
        // return response.data.item_sale_data

        return [
          // response.data?.item_data,
          response.data.item_sale_data,
          response.data.net_sale,
          response.data.total_sold,
          response.data.status,
        ];
      } else {
        return [];
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled:", error.message);
        return;
      }
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

// TOP PRODUCT SOLD-------------------
export const fetchTopProductSold = createAsyncThunk(
  "ItemSalesSlice/fetchTopProductSold",
  async (data, { rejectWithValue }) => {
    try {
      const { token, ...dataNew } = data;
      const apiUrl =
        IS_PY_GRAPHS === true || IS_PY_GRAPHS === "true"
          ? REPORTS_BASE_URL + REPORTS_TOP_SOLD_PRODUCTS
          : BASE_URL + GET_TOP_PRODUCT_SOLD;
      const response = await axios.post(apiUrl, dataNew, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.status === true) {
        // return response.data.item_sale_data

        return [
          response.data?.item_data,
          // response.data.item_sale_data,
          response.data.net_sale,
          response.data.total_sold,
          response.data.status,
        ];
      }
    } catch (error) {
      // throw new Error(error.response.data.message);
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);
// TOP PRODUCT SOLD-------------------
const ItemSalesSlice = createSlice({
  name: "ItemSalesSlice",
  initialState,
  reducers: {
    clearAllStateInItemSalesSlice: (state) => {
      state.ItemSalesData = [];
      state.GetTopProductSold = [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchItemSalesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchItemSalesData.fulfilled, (state, action) => {
      state.loading = false;
      state.ItemSalesData = action.payload || [];
      state.status = action.payload.length > 0 ? action.payload[3] : false; // status ke basis pe khel khela hai
      state.error = "";
    });

    builder.addCase(fetchItemSalesData.rejected, (state, action) => {
      state.loading = false;
      state.ItemSalesData = [];
      state.status = false;
      state.error = action.error.message;
    });
    // ----------fetch top product sold--------
    builder.addCase(fetchTopProductSold.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchTopProductSold.fulfilled, (state, action) => {
      state.loading = false;
      state.GetTopProductSold = action.payload;
      state.error = "";
    });
    builder.addCase(fetchTopProductSold.rejected, (state, action) => {
      state.loading = false;
      state.GetTopProductSold = [];
      state.error = action.error.message;
    });
    // ----------fetch top product sold--------
  },
});
export const { clearAllStateInItemSalesSlice } = ItemSalesSlice.actions;
export default ItemSalesSlice.reducer;
